<div class="list-group-item requiredAction" *hideKey="'Profile-SeoContentSurvey'">
    <div class="d-flex flex-wrap mb-2">
      <div class="mb-1 text-danger custom-required-actions-item-title" style="min-width: 100%">
        <i class="fa fa-exclamation-circle fa-2x text-danger float-start pe-2"></i>{{ 'ra_content_survey_response_needed' | translate }}
      </div>
      <div class="text-muted ms-4 mb-2" style='min-width: 38%'>
        <small>
          <span class="customer-required-actions-text font-italic">
            {{ 'ra_seo_content_survey_desc' | translate }}
          </span>
        </small>
      </div>
      <div class="ms-auto" style="min-width: 38%">
        <button routerLink="/user/seo-content-survey" class="btn btn-primary btn-sm align-self-start custom-required-actions-item-button w-100">
          {{ 'seo_content_survey.content_survey' | translate }}
        </button>
      </div>
    </div>
  </div>
